import { render, staticRenderFns } from "./CloseOrder.vue?vue&type=template&id=6296a6ec&lang=pug"
import script from "./CloseOrder.vue?vue&type=script&lang=js"
export * from "./CloseOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports